import { Button } from "@msuite/ui/button";
import { useTranslation } from "@msuite/ui/localization";
import { Modal } from "@msuite/ui/modal";
import { ModalLoadFailedContent } from "./modal-load-failed-content";

/** Props Interface */
interface ModalLoadFailedProps {
	/**
	 * Renders the close control. A modal that already brings its own footer —
	 * a confirm modal, for instance — takes `ModalLoadFailedContent` directly
	 * instead of this component.
	 */
	onClose: () => void;
}

export function ModalLoadFailed({ onClose }: ModalLoadFailedProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<>
			<Modal.Body>
				<ModalLoadFailedContent />
			</Modal.Body>
			<Modal.Footer>
				<Button
					variant="ghost"
					onClick={onClose}
					className="ml-auto"
				>
					{t("general.close")}
				</Button>
			</Modal.Footer>
		</>
	);
}
